import { TCustomField } from '../../types/TCustomField';

const parseCustomFields = (customNotes: { [key: string]: any } | undefined) => {
  if (customNotes) {
    const customFields: TCustomField[] = [];

    Object.keys(customNotes).forEach((k) => {
      const value = customNotes[k].toString().trim(); // guard for trimming number values

      if (value) {
        customFields.push({ key: k, value });
      }
    });

    return customFields.length ? customFields : undefined;
  }

  return undefined;
};

export default parseCustomFields;
